import { useCallback } from 'react';
import { useAppDispatch } from '../../../../../../app/store';
import { NoteView, removeNote } from '../../../../../../services/CaseManagementService';
import { useGetMyProfileQuery } from '../../../../../../services/ProfileService';

interface UseViewNoteReturn {
  canDelete: boolean;
  handleDelete: () => void;
  formatDate: (dateString: string) => string;
}

export const useViewNote = (note: NoteView | null, onClose: () => void): UseViewNoteReturn => {
  const dispatch = useAppDispatch();
  const { data: userProfile } = useGetMyProfileQuery();

  const canDelete = (() => {
    if (!note || !userProfile) return false;
    const currentUserIdentity = userProfile.identity || userProfile.name;
    return note.addedBy === currentUserIdentity;
  })();

  const handleDelete = useCallback(() => {
    if (!note?.noteId) return;

    const confirmed = window.confirm(
      'Are you sure you want to delete this note? This action cannot be undone.'
    );
    
    if (confirmed) {
      dispatch(removeNote(note.noteId));
      onClose();
    }
  }, [note, dispatch, onClose]);

  const formatDate = useCallback((dateString: string): string => {
    if (!dateString) return 'Unknown';
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }, []);

  return {
    canDelete,
    handleDelete,
    formatDate
  };
};
